import { GET_PLAN_DETAIL_ASYNC } from '../constants/constant.action'

export function getPlanDetail(memberIdObj) {
  return {
    type: GET_PLAN_DETAIL_ASYNC,
    payload: memberIdObj,
  }
}
